import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { Question, QuestionAnswer } from 'src/app/interfaces/question'
import { QuestionAnswerOption } from './../../../../interfaces/question'

interface MultiSelectQuestionAnswerOption extends QuestionAnswerOption {
  checked?: boolean
}

@Component({
  selector: 'question-multi-select',
  template: `
    <div *ngIf="question" class="multi-select-question-wrapper">
      <div
        class="checkbox-button-wrapper"
        *ngFor="let option of answerOptions; let idx = index"
        click
        [elementName]="'checkbox'"
        (throttledClick)="onClickCheckbox(option)"
      >
        <span class="not-checked" *ngIf="!option.checked"></span>
        <span class="checked" *ngIf="option.checked"><img [src]="'assets/icons/icon-check.png' | imageUrl" /></span>
        <span class="value">{{ option.value }}</span>
        <input id="checkbox-{{ option.id }}" type="checkbox" [value]="option.id" [checked]="option.checked" />
      </div>
    </div>
  `,
  styleUrls: ['./multi-select-question.component.scss'],
})
export class MultiSelectQuestionComponent implements OnInit, OnChanges {
  @Input() question: Question | undefined
  @Input() maxSelectCount: number | undefined
  @Output() answered = new EventEmitter<QuestionAnswer>()
  selectedOptions = new Set<number>()
  answerOptions: MultiSelectQuestionAnswerOption[] = []

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('question') && changes.question.currentValue !== undefined) {
      this.answerOptions = [...(this.question?.answerOptions ?? [])]
    }
  }

  /**
   * 이미 최대치로 check되었을 경우, 추가 체크 동작은 무시
   */
  onClickCheckbox(option: MultiSelectQuestionAnswerOption): void {
    if (this.question === undefined) {
      return
    }
    if (this.maxSelectCount !== undefined && !option.checked) {
      const answeredCount = (this.answerOptions.map((option) => (option.checked ? 1 : 0)) as number[]).reduce(
        (acc, option) => acc + option
      )
      if (answeredCount === this.maxSelectCount) {
        return
      }
    }
    option.checked = !option.checked

    const selectedOptionId = option.id
    if (option.checked) {
      this.selectedOptions.add(selectedOptionId)
    } else {
      this.selectedOptions.delete(selectedOptionId)
    }
    this.answered.emit({
      ...option,
      options: [...this.selectedOptions],
      questionAnswerSet: [
        {
          question: this.question,
          metaRelations: [],
        },
      ],
    })
  }
}
